import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IdmClientSecretAutoRotationConfig } from 'src/app/models/graph/applications/IdmClientSecretAutoRotationConfig';
import { IDialogCreateClientSecretAutoRotationConfigData } from 'src/app/models/idm/IDialogCreateClientSecretAutoRotationConfigData';

@Component({
  selector: 'app-dialog-create-client-secret-auto-rotation-config-form',
  templateUrl: './dialog-create-client-secret-auto-rotation-config-form.component.html',
  styleUrl: './dialog-create-client-secret-auto-rotation-config-form.component.css'
})
export class DialogCreateClientSecretAutoRotationConfigFormComponent {
  constructor(private dialogRef: MatDialogRef<DialogCreateClientSecretAutoRotationConfigFormComponent>, @Inject(MAT_DIALOG_DATA) public data: IDialogCreateClientSecretAutoRotationConfigData) { }

  saveConfig(data: IdmClientSecretAutoRotationConfig[]) {
      this.dialogRef.close(data);
  }

  cancelled() {
      this.dialogRef.close();
  }
}
